
import {Mui} from "@osu/react-ui"

function Divider() {
    return <Mui.Divider className="margin-y-1" />;
}

export default Divider